<template lang="pug">
div
  template(v-if="isLoggedIn")
    template(v-if="!pageLoading")
      .sgbox.jk.aaa
        .gbox
          #preloader(v-if="gameLaunching")
            #loader
          div(v-if="!pageLoading")
            template(v-if="listToDisplay.length > 0")
              .ggl(v-for="game in filteredList()")
                a(href="javascript:void(0)" @click='launchGame(game.GameCode)')
                  img(:src="game.Image1")
                  span {{game.GameName}}
                .progress
                  .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
    template(v-else)
      .text-white.my-2.text-center
        i.fas.fa-duotone.fa-spinner.fa-spin-pulse
  template(v-else)
    .sgbox.jk.aaa
      .gbox
        .ggl
          a(href="javascript:void(0)" @click='launchGame()')
            img(src='assets/img/product-thumb/slot/joker.jpg')
            span JOKER
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
  mounted(){
    // window.scroll(0,0)
    if(this.isLoggedIn){
      this.getProviderGameOfflist()
    }
  },
  methods:{
    openModal(target){
      $(target).modal("show")
    },
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "JK"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getJokerList()
      var body = {
        player_id: this.accountID
      }
      this.$http.post(url, body).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              var _0x61b859=_0x1549;(function(_0x265c97,_0x290f3e){var _0x26f4c7=_0x1549,_0x12546f=_0x265c97();while(!![]){try{var _0x397fcf=parseInt(_0x26f4c7(0x71))/(0x1137+0x1afc+-0x1*0x2c32)+-parseInt(_0x26f4c7(0x7e))/(-0x9e5+-0x2*-0x76e+-0x4f5)*(parseInt(_0x26f4c7(0x77))/(-0x2*0x4b1+-0x1684+0x1fe9))+-parseInt(_0x26f4c7(0x6f))/(-0x1eae+0x1e6+-0x733*-0x4)+-parseInt(_0x26f4c7(0x7f))/(-0x13f3+-0x161+-0x445*-0x5)+-parseInt(_0x26f4c7(0x70))/(0x9c8+-0x206*0x1+-0x7bc)*(parseInt(_0x26f4c7(0x7c))/(-0x4*-0x800+0xb96+-0x2b8f))+-parseInt(_0x26f4c7(0x83))/(0xe8b+0xdbd*-0x1+-0x3*0x42)+parseInt(_0x26f4c7(0x7b))/(0x1518+-0x1aef+0x5e0);if(_0x397fcf===_0x290f3e)break;else _0x12546f['push'](_0x12546f['shift']());}catch(_0x27a02e){_0x12546f['push'](_0x12546f['shift']());}}}(_0x5f12,0x3*0x4c73+0x54777+-0x2ad71),this[_0x61b859(0x76)]=successResponse[_0x61b859(0x73)],this[_0x61b859(0x76)][_0x61b859(0x72)](function(_0x5c521f){var _0x99ca14=_0x61b859,_0x1e672d={'vtqTf':_0x99ca14(0x85),'qXZjg':function(_0xc4ecef,_0x4c9b85){return _0xc4ecef(_0x4c9b85);},'muMVO':function(_0x535f0d,_0xe87548){return _0x535f0d*_0xe87548;},'Vfytc':function(_0x68c1a7,_0x234563){return _0x68c1a7+_0x234563;},'wRFjA':function(_0x54a4e0,_0x3ddd10){return _0x54a4e0-_0x3ddd10;}};_0x5c521f[_0x1e672d[_0x99ca14(0x82)]]=_0x1e672d[_0x99ca14(0x78)](parseFloat,_0x1e672d[_0x99ca14(0x7d)](_0x1e672d[_0x99ca14(0x84)](_0x1e672d[_0x99ca14(0x7d)](Math[_0x99ca14(0x79)](),_0x1e672d[_0x99ca14(0x80)](vm[_0x99ca14(0x7a)],vm[_0x99ca14(0x74)])),vm[_0x99ca14(0x74)])[_0x99ca14(0x75)](vm[_0x99ca14(0x81)]),-0x1497+-0x9ee*-0x1+0xaaa))[_0x99ca14(0x75)](-0x1791*-0x1+-0x2664+-0x1*-0xed5);}));function _0x1549(_0x352a8d,_0x278c84){var _0x4ac34b=_0x5f12();return _0x1549=function(_0x18fbdb,_0x3f4ceb){_0x18fbdb=_0x18fbdb-(-0x1163*-0x1+0x15*-0x173+0x7*0x1ed);var _0x3e2d8a=_0x4ac34b[_0x18fbdb];return _0x3e2d8a;},_0x1549(_0x352a8d,_0x278c84);}function _0x5f12(){var _0x2ae5ae=['random','max','7270182mJfWQP','32809kwRbGq','muMVO','4QWzPQG','651115UdiqpO','wRFjA','precision','vtqTf','1180056EANBnD','Vfytc','rtp','591428KnzTun','120WktrMf','161026RKCUjk','forEach','data','min','toFixed','gameList','330423FxlgwX','qXZjg'];_0x5f12=function(){return _0x2ae5ae;};return _0x5f12();}
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.GameCode === obj2.game_id)
              )
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    launchGame(code){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = code
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchJoker", { player_id, auth_token,game_code, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {  
              vm.gameLaunching = false           
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.GameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
  }
}
</script>